import CELL_DATA_TYPES from '../cell-types.config';

// Engagement module configurations
export const LISTING_ACTIVE_USERS_COLUMNS = [
  {
    id: 'platform',
    label: 'Platform',
    align: 'left',
    dataKey: 'platform',
    type: CELL_DATA_TYPES.PLATFORM,
  },
  {
    id: 'deviceCount',
    label: 'Active User Count',
    align: 'right',
    dataKey: 'deviceCount',
    type: CELL_DATA_TYPES.NUMBER,
  },
];

export const LISTING_CONTENT_PLAYS_COLUMNS = [
  {
    id: 'platform',
    label: 'Platform',
    align: 'left',
    dataKey: 'platform',
    type: CELL_DATA_TYPES.PLATFORM,
  },
  {
    id: 'videoPlayCount',
    label: 'User Play Count (Video)',
    align: 'right',
    dataKey: 'videoPlayCount',
    type: CELL_DATA_TYPES.NUMBER,
  },
  {
    id: 'audioPlayCount',
    label: 'User Play Count (Audio)',
    align: 'right',
    dataKey: 'audioPlayCount',
    type: CELL_DATA_TYPES.NUMBER,
  },
];

export const LISTING_APP_SESSIONS_COLUMNS = [
  {
    id: 'platform',
    label: 'Platform',
    align: 'left',
    dataKey: 'platform',
    type: CELL_DATA_TYPES.PLATFORM,
  },
  {
    id: 'totalAppSession',
    label: 'Total App Sessions',
    align: 'right',
    dataKey: 'totalAppSession',
    type: CELL_DATA_TYPES.NUMBER,
  },
  {
    id: 'totalClosedAppSession',
    label: 'Total Closed App Sessions*',
    align: 'right',
    dataKey: 'totalClosedAppSession',
    type: CELL_DATA_TYPES.NUMBER,
  },
  {
    id: 'totalDurationInMinutes',
    label: 'Total Duration (Minutes)*',
    align: 'right',
    dataKey: 'totalDurationInMinutes',
    type: CELL_DATA_TYPES.NUMBER,
  },
  {
    id: 'avgDurationPerSession',
    label: 'Average Duration Per Session (Minutes)*',
    align: 'right',
    dataKey: 'avgDurationPerSession',
    type: CELL_DATA_TYPES.NUMBER,
  },
];
